module.exports = __webpack_public_path__ + "media/images/lb/426-a9d389d4968a07d3a2c55b8c3d759e96.svg";